export const openComplianceScheduleType = {
  'AO': 'Adminitrative Order',
  'LH': 'Legal Hearing',
  'CCR': 'CCR SCHEDULES',
  'DEFY': 'Physical Deficiency Schedule',
  'TRMT': 'Treatment Report Schedule',
  'BCA': 'BCA COMPLIANCE SCHEDULES',
  'ENG': 'ENGINEERING ACTIVITY TYPES',
  'CAP': 'CORRECTIVE ACTION PLAN',
  'GWR': 'Groundwater Rule',
  'WTTC': 'WELCOME TO THE CLUB LETTER SCHEDULE',
  'OEL': 'Operational Evaluation Level',
  'LCNT': 'Lead Consumer Notice',
  'CC': 'CORROSION CONTROL',
  'WQPN': 'TIER 2 Public Notice required on a regular basis for continued Quality violations',
  'UDI': 'Schedules for systems with a UDI classified source',
  'RTCR': 'Revised Total Coliform Rule',
  'PBCU': 'LEAD/COPPER FOLLOW UP SCHEDULE',
  'LCSP': 'Lead Copper Sampling Site Plan',
  'ENPN': 'Enforcement Requiring Public Notice',
  'ADFY': 'Administrative deficiency schedule',
  'DBSP': 'Disinfection Byproduct Sample Site Plan',
  'CAA': 'Corrective Action Agreement',
  'NAO': 'Not Approved Order',
  'DNO': 'Do Not Open Order',
  'LCCC': 'Submit Lead/Copper Corrosion Control',
  'MRPN': 'Tier-3 Public Notice for Failure to Monitor',
  'RPNC': 'Repeated Non Compliance-Monitoring and Reporting. All Future Failure To Monitor Violations must stay on for 12 months following the Return to Compliance Date',
  'TOP': 'TEMPORARY OPERATING PERMIT',
  'TE': 'TEMPORARY EXCEPTION',
  'OC': 'OPERATOR CERTIFICATION',
  'PN': 'PUBLIC NOTICE',
  '': ''
};